// Assuming HttpStatusCode is an enum or a set of constants
import { MatrixError } from 'matrix-js-sdk/lib/http-api/errors';

export enum HttpStatus {
  ServiceUnavailable = 503,
  Forbidden = 403,
  NotFound = 404,
  BadRequest = 400,
  InternalServerError = 500
}

/**
 * Implementation of mandatory errors expected to get returned by a gematik TI-M Testtreiber
 * Umgesetze AFOs:
 * A_25363 - Testtreiber-Modul
 * A_25361 - keine Modifikation der Inhalte */
export class ErrorWithStatus extends Error {
  constructor(
    public error: string,
    public status: number,
    message: string
  ) {
    super(message);
  }

  asJsonError(): Error {
    return new Error(JSON.stringify({ error: this.error, status: this.status, message: this.message }));
  }
}

export function jsonError(error: string, status: number, message: string): Error {
  return new Error(JSON.stringify({ error, status, message }));
}

export function matrixErrorAsJson(errorName: string, error: MatrixError): Error {
  return new Error(
    JSON.stringify({
      error: errorName,
      status: error.httpStatus ?? 0,
      errorCode: error.errcode,
      message: `MatrixError: [${error.httpStatus}] ${error.data.error} (${error.url})`
    })
  );
}
